import React from "react";
import Title from "./title/Title";
import Profile from "./profile/Profile";
import Qual from "./Qualification/Qual";
import Skills from "./mySkills/Skills";
import SocialMedia from "./socialMedia/SocialMedia";

export default function Home() {
  return (
    <div>
      <div className="container">
        <Title />
        <div className="body">
          <Profile />
          <Qual />
        </div>
        <hr />
        <Skills />
        <hr />
        <SocialMedia />
      </div>
    </div>
  );
}
